export default __webpack_public_path__ + "static/media/Set's Judgement.26cdec6b.jpg";